// extracted by mini-css-extract-plugin
export var btn = "z_mD s_r4 s_rP d_bw d_bL d_bz d_ds";
export var full = "z_td d_s d_D";